// require("./lib/pym");
require("./analytics");
const classify = require("./lib/classify");
const dayjs = require("dayjs");
const track = require("./lib/tracking");

//STATE DATA
const stateData = window.STATEDATA;
const generalData = window.GENERALDATA;
const strings = window.STRINGS;

const deadlineSources = [
  { raceType: "primary", label: "Primary", data: window.STATEDATA },
  { raceType: "general", label: "General", data: window.GENERALDATA },
];

const root = document.getElementById("deadline-container");
const stateSelector = document.querySelector("#state-selector");

//TODAY'S DATE
const todaysDate = dayjs().startOf("day");

const changeState = e => {
  track("state changed");

  const state = e.target.value;
  const stateSlug =
    state === "District of Columbia" ? "washington-dc" : classify(state);
  const url = "./" + stateSlug + ".html";

  window.location.href = url + window.location.search;
};

stateSelector.addEventListener("change", changeState);

function createDeadlineElements(data, type = "") {
  // INCLUDES VA REFERENDUM HACK
  const isElectionDay =
    data[2].includes("election day") || data[2].includes("referendum");

  const dateElement = document.createElement("span");
  dateElement.className = `table-text table__date-col mobile-dotted-line${
    type === "compact" ? " hidden" : ""
  } ${isElectionDay ? "election-day" : ""}`;
  dateElement.innerHTML = type === "compact" ? "" : `<span>${data[0]}</span>`;

  const stateElement = document.createElement("span");
  stateElement.className = `table-text table__place-col dotted-line ${isElectionDay ? "election-day" : ""}`;
  stateElement.innerHTML = `<span><a href=${classify(data[1])}.html>${
    data[1]
  }</a></span>`;

  const locationElement = document.createElement("span");
  locationElement.className = `table-text table__description-col ${isElectionDay ? "election-day" : ""}`;
  locationElement.innerHTML = data[2];

  return { dateElement, stateElement, locationElement };
}

function convertToNestedObject(dateObj) {
  let nestedObj = {};

  // Iterate over each month (key in dateObj)
  for (let month in dateObj) {
    nestedObj[month] = {}; // Initialize the nested object for each month

    // Iterate through each array in the month
    dateObj[month].forEach(entry => {
      let dateKey = entry[0]; // Get the first element as the key (e.g., "Sat. 6")

      // If the date key doesn't exist yet, create an array for it
      if (!nestedObj[month][dateKey]) {
        nestedObj[month][dateKey] = [];
      }

      // Push the entire array (including the date) into the array for that date key
      nestedObj[month][dateKey].push(entry);
    });
  }

  return nestedObj;
}

function getHomePageDeadlines(source, limit) {
  const deadlineData = source.data;
  const dateObj = {};
  deadlineData &&
    deadlineData.map((state, i) => {
      const inPersonDate = state["In-person deadline"];
      const byMailDate = state["Mail registration deadline"];
      const onlineDate = state["Online registration deadline"];
      const electionDate = state["Primary Election Date"];

      const inPersonDateDeadline = dayjs(inPersonDate + ", 2026");
      const byMailDateDeadline = dayjs(byMailDate + ", 2026");
      const onlineDateDeadline = dayjs(onlineDate + ", 2026");
      const electionDateDeadline = dayjs(electionDate + ", 2026");

      const inPersonDiffDate = inPersonDateDeadline.diff(
        todaysDate,
        "day",
        true,
      );
      const byMailDiffDate = byMailDateDeadline.diff(todaysDate, "day", true);
      const onlineDiffDate = onlineDateDeadline.diff(todaysDate, "day", true);
      const electionDiffDate = electionDateDeadline.diff(
        todaysDate,
        "day",
        true,
      );

      const dates = {
        inPerson: inPersonDateDeadline,
        byMail: byMailDateDeadline,
        online: onlineDateDeadline,
        election: electionDateDeadline,
      };

      const groupedByDate = {};

      for (const [type, date] of Object.entries(dates)) {
        if (!date) continue;

        const daysAway = date.diff(todaysDate, "day", true);

        if (daysAway >= 0 && (limit === 0 || daysAway <= limit)) {
          groupedByDate[date] ??= [];
          groupedByDate[date].push(type);
        }
      }

      Object.entries(groupedByDate).forEach(([date, types]) => {
        const mode_label = {
          inPerson: "In-person",
          byMail: "Mail",
          online: "Online",
        };

        const election_key = "election";
        var election_label = "Primary election day";
        // INCLUDES VA REFERENDUM HACK
        if (
          state.State == "Virginia" &&
          state["Primary Election Date"] === "Tuesday, April 21"
        ) {
          election_label = "Special election day for redistricting referendum";
        }

        function joinSeries(items) {
          if (items.length <= 1) return items[0] ?? "";
          if (items.length == 2)
            return `${items[0]} and ${items[1].toLowerCase()}`;
          return `${items[0]}, ${items[1].toLowerCase()} and ${items.at(-1).toLowerCase()}`;
        }

        function buildLabel(types) {
          const hasElection = types.includes(election_key);

          const modes = types
            .filter(t => t !== election_key)
            .map(t => mode_label[t] ?? t);

          if (hasElection && modes.length === 0) {
            return `<strong>${election_label}</strong>`;
          }

          const registration_part = `${joinSeries(modes)} registration`;

          if (!hasElection) {
            return registration_part;
          }
          return `<strong>${election_label}</strong>&nbsp;&mdash; ${registration_part} available`;
        }

        const mode_order = ["Mail", "Online", "In-person"];

        types.sort((a, b) => mode_order.indexOf(a) - mode_order.indexOf(b));
        const label = buildLabel(types);

        const month = dayjs(date).format("MMMM");
        const day = dayjs(date).format("D");
        const week = dayjs(date).format("ddd");

        dateObj[month] ??= [];
        dateObj[month].push([`${week}. ${day}`, state.State, label]);
      });
    });

  function renderMonth({
    dateObj,
    monthName,
    headerEl,
    boxEl,
    countLimit,
    extractDay,
    convertToNestedObject,
    createDeadlineElements,
  }) {
    if (Array.isArray(dateObj[monthName])) {
      dateObj[monthName].sort((a, b) => extractDay(a[0]) - extractDay(b[0]));
    } else {
      headerEl.remove();
      return;
    }

    const nestedObj = convertToNestedObject(dateObj);
    const monthObj = nestedObj?.[monthName];

    if (!monthObj) {
      return;
    }

    // let count = 0;

    Object.keys(monthObj).forEach(dates => {
      // count++;
      // if (count >= countLimit) return;

      monthObj[dates].forEach((details, index) => {
        const label = index === 0 ? dates : "compact";
        const { dateElement, stateElement, locationElement } =
          createDeadlineElements(details, label);
        headerEl.style.display = "block";
        boxEl.append(dateElement, stateElement, locationElement);
      });
    });
  }

  // const monthsToRender = [
  //   { monthName: "February", headerEl: februaryHeader, boxEl: februaryBox },
  //   { monthName: "March", headerEl: marchHeader, boxEl: marchBox },
  //   { monthName: "April", headerEl: aprilHeader, boxEl: aprilBox },
  //   { monthName: "May", headerEl: mayHeader, boxEl: mayBox },
  //   { monthName: "June", headerEl: juneHeader, boxEl: juneBox },
  //   { monthName: "July", headerEl: julyHeader, boxEl: julyBox },
  //   { monthName: "August", headerEl: augustHeader, boxEl: augustBox },
  //   { monthName: "September", headerEl: septemberHeader, boxEl: septemberBox },
  //   { monthName: "October", headerEl: octoberHeader, boxEl: octoberBox },
  // ];

  function capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  const months = [
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
  ];

  function createMonthSection(month) {
    const name = capitalize(month);

    const header = document.createElement("h3");
    header.className = "subhed subhed--dark subhed--line";
    header.id = `${month}-header`;

    const span = document.createElement("span");
    span.textContent = name;
    header.appendChild(span);

    const box = document.createElement("div");
    box.className = "flexbox";
    box.id = month;

    return {
      headerEl: header,
      boxEl: box,
    };
  }

  months.forEach(month => {
    const { headerEl, boxEl } = createMonthSection(month);

    root.appendChild(headerEl);
    root.appendChild(boxEl);

    const name = capitalize(month);

    renderMonth({
      dateObj,
      monthName: name,
      headerEl,
      boxEl,
      countLimit: 100,
      extractDay,
      convertToNestedObject,
      createDeadlineElements,
    });
  });

  return Object.keys(dateObj).length;
}

// Function to extract the day number from the string (e.g., "5" from "Wed. 5")
function extractDay(dateStr) {
  return parseInt(dateStr.split(". ")[1]);
}

function initHomePage() {
  const isHomepage = document.getElementById("deadlines");

  if (!isHomepage) {
    return;
  }

  const contentEl = document.querySelector("#tab-content");
  const buttons = document.querySelectorAll(".tab-button");
  const subhedEl = document.getElementById("subhed");
  const introEl = document.getElementById("intro");

  function renderTab(tabName) {
    root.replaceChildren();

//     if (tabName == "primary") {
//   var subhed = strings.homepageIntroHeader;
//   var intro = strings.homepageIntroText;
// }
// else {
  var subhed = strings.homepageIntroHeaderGeneral;
  var intro = strings.homepageIntroTextGeneral;
// }
    
    subhedEl.innerHTML = subhed;
    introEl.innerHTML = intro;


    const limit = 0;
    const elextype = tabName;
    const source = deadlineSources.find(source => source.raceType === elextype);
    const hasDates = getHomePageDeadlines(source, limit);
  }

  buttons.forEach(button => {
    button.addEventListener("click", () => {
      const tabName = button.dataset.tab;

      buttons.forEach(btn => {
        const isActive = btn === button;
        btn.classList.toggle("active", isActive);
        btn.setAttribute("aria-selected", String(isActive));
      });

      renderTab(tabName);
    });
  });

  renderTab("general");
}

// window.onload = getHomePageDeadlines();
window.addEventListener("DOMContentLoaded", initHomePage());

// piano
var oldonload = window.onload;

window.onload =
  typeof window.onload != "function"
    ? tp.experience.execute()
    : function () {
        oldonload();
        tp.experience.execute();
      };
